module.exports = __webpack_public_path__ + "static/media/ic_leak.57432b34.png";